// A böngésző saját UI-ja (pl. Facebook in-app böngésző alsó sávja) miatti
// eltakarást hivatott kompenzálni ott, ahol az env(safe-area-inset-bottom)
// nem ad helyes értéket. Ennél nagyobb eltérés a visible és layout viewport
// magassága közt valójában a mobil billentyűzet megnyílása - azt viszont
// nem szabad ráengedni a lenti sticky sávra, mert szinte az egész képernyőt
// elfoglalná.
const MAX_VISIBLE_VIEWPORT_INSET_BOTTOM = 60;

export function initVisualViewportInset() : void {
    const { visualViewport } = window;

    if (!visualViewport) {
        return;
    }

    const update = () => {
        const inset = Math.min(
            MAX_VISIBLE_VIEWPORT_INSET_BOTTOM,
            Math.max(
                0,
                window.innerHeight - (visualViewport.height + visualViewport.offsetTop),
            ),
        );

        document.documentElement.style.setProperty('--visible-viewport-inset-bottom', `${inset}px`);
    };

    visualViewport.addEventListener('resize', update);
    visualViewport.addEventListener('scroll', update);
    update();
}
